import axios from 'axios';
import { message } from 'ant-design-vue';
import { sendError } from '@/utils/sentry';

// Set config defaults when creating the instance
const instance = axios.create({
  // baseURL: import.meta.env.DEV ? '/api' : 'http://api.tosoiot.com',
});

// Alter defaults after instance has been created
// instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

instance.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    const { data, config } = response;
    // console.log('interceptors', response);
    const { Code, code, Message, msg } = data;

    if (Code !== undefined && Code !== 200 && Code !== 0) {
      !config.silent && message.error(Message);
      sendError(`requestError: ${Code}-${Message}`);
      return Promise.reject(Message);
    }
    if (code !== undefined && +code !== 0 && +code !== 1000) {
      !config.silent && message.error(msg);
      // 未登录这种场景不上报打点
      +code !== 1003 && sendError(`requestError: ${code}-${msg}`);
      return Promise.reject(msg);
    }
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return config.verboseRes ? response : data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default instance;
